import { Forward } from "components/common/Icons";
import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";

function HeaderTitle({ children }: { children: React.ReactNode }) {
  return <p className={`${TYPO.TYPO7_MD} text-gray80`}>{children}</p>;
}
function HeaderSubTitle({ children }: { children: React.ReactNode }) {
  return <p className={`${TYPO.TYPO8_RG} text-gray60`}>{children}</p>;
}

function Header({
  children,
  score,
}: {
  children: React.ReactNode;
  score?: number;
}) {
  const { t } = useTranslation("detail");
  const isUp = score ? score >= 50 : false;

  return (
    <div
      className="px-4 py-3 flex  gap-3 items-center"
      style={{
        background: isUp
          ? "linear-gradient(86deg, rgba(246, 247, 249, 0.00) 50%, rgba(39, 138, 244, 0.05) 82.31%), var(--gray2) "
          : "linear-gradient(86deg, rgba(246, 247, 249, 0.00) 50%, rgba(244, 73, 39, 0.05) 82.31%), var(--gray2)",
      }}
    >
      <div className="flex flex-col grow">{children}</div>
      <div
        className={`w-[48px] h-[48px] px-[6px] rounded-full border  flex items-center justify-center ${
          isUp ? "border-blue40" : "border-red40"
        }`}
      >
        <p
          className={`${TYPO.TYPO8_SB} ${
            isUp ? "text-blue40" : "text-red40"
          } whitespace-nowrap`}
        >
          {t("scorePoints", { score })}
        </p>
      </div>
    </div>
  );
}
Header.Title = HeaderTitle;
Header.SubTitle = HeaderSubTitle;

function ViewMore({
  onClick,
  type,
}: {
  onClick: () => void;
  type: "mmt" | "fin" | "sharpe";
}) {
  const { t } = useTranslation("detail");
  return (
    <div
      className="px-4 py-[10px] flex justify-between items-center cursor-pointer  border-t border-gray15 z-[1] bg-gray2"
      onClick={onClick}
      data-gtm-id={`sDetail-diagnosis-view-${type}-more-button`}
    >
      <p className={`${TYPO.TYPO7_MD} text-gray80`}>{t("details")}</p>
      <Forward fill="gray40" width={12} height={12} />
    </div>
  );
}

function ContentWrapper({
  children,
  height,
  ...props
}: {
  children: React.ReactNode;
  height: number;
} & React.HTMLAttributes<HTMLDivElement>) {
  const [maxHeight, setMaxHeight] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setMaxHeight(height);
    }, 10);
  }, []);
  return (
    <div
      style={{
        maxHeight: `${maxHeight}px`,
        opacity: maxHeight > 0 ? 1 : 0,
        transition:
          "max-height 0.6s 0.1s ease-in-out, opacity 0.5s 0.2s ease-in-out",
      }}
      {...props}
    >
      <div>{children}</div>
    </div>
  );
}
function Content({
  children,
  ...props
}: { children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className="px-4 py-[10px] flex items-center gap-2 bg-white border-t border-gray15"
      {...props}
    >
      {children}
    </div>
  );
}
function DiagnosisLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-gray2 rounded-[14px] flex flex-col border border-gray15 overflow-hidden box-border">
      {children}
    </div>
  );
}
DiagnosisLayout.Header = Header;
DiagnosisLayout.ViewMore = ViewMore;
DiagnosisLayout.ContentWrapper = ContentWrapper;
DiagnosisLayout.Content = Content;
export default DiagnosisLayout;
